<template>
  <div class="product-page">
    <div class="main-container header-section">
      <div class="header-top">
        <h1 class="brand-title">ALL {{ categoryName ? categoryName : typeFilter[formData.type] }}</h1>
      </div>
      <div class="filter-bar" v-show="formData.type != 0">
        <span class="filter-item" @click="filterByType({ craftId: '' })"
          :class="{ 'active': !sleTypeData || !sleTypeData.craftId }">ALL</span>
        <el-popover placement="bottom" trigger="hover" class="control-dropdown">
          <span class="el-dropdown-link" slot="reference" v-show="formData.type != 2 && typeList.length > 0">
            {{ sleTypeData.craftTitle || 'CONTROL' }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <div>
            <div v-for="item in typeList" :key="item.id" class="filter-li" @click="filterByType(item)">
              <span> {{ item.craftTitle }}</span>
            </div>
          </div>
        </el-popover>
      </div>
    </div>


    <div class="main-container list-section">
      <el-row :gutter="30" v-loading="loading">
        <!-- xs=12(手机2列), sm=12(平板2列), md=8(中屏3列), lg=6(大屏4列) -->
        <el-col v-for="(item, index) in products" :key="item.id" :xs="12" :sm="12" :md="8" :lg="6" :xl="6"
          class="product-col">
          <div class="product-card" @click="handleImageClick(item)">
            <div class="image-wrapper">
              <transition name="fade">
                <img :key="item.activeColorIdx" :src="getProductImage(item)" alt="Product Image" class="product-img">
              </transition>
            </div>
            <!-- 信息容器 -->
            <div class="info-wrapper">
              <div class="product-name">{{ item.productName }}</div>
              <!-- <p class="product-desc">{{ item.craftName }}</p> -->
              <!-- 色块选择区域 (点击切换事件) -->
              <div class="color-swatches">
                <div v-for="(val, inx) in item.productColorPojoList" :key="inx" class="swatch-item"
                  :class="{ active: item.activeColorIdx == inx }" @click.stop="switchColor(index, inx)"  v-show="screenWidth <=  768 ? inx < 5 :true">
                  <img :src="imageUtils(websiteImg, val.cover)"  v-show="inx < 4 || screenWidth > 768">
                  <span v-show="inx == 4 && item.productColorPojoList.length > 4 && screenWidth <= 768" style="font-size: 7rem;"> ...</span>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 分页区域 -->
    <!-- <div class="pagination-section" v-show="total > 0 && products && products.length > 0">
      <el-pagination layout="prev, pager, next, slot" :total="total" :current-page.sync="formData.pageNo"
        prev-text="< Previous" next-text="Next >" @current-change="getList">
      </el-pagination>
    </div> -->
  </div>
</template>

<script>
import "@/style/goodList.scss";
import { materialList, productCraftList } from '@/api/goods';
import { imageUtils } from '@/utils/imageUtil';
import utils from '@/utils/util.js';
import { mapGetters } from "vuex";


export default {
  data() {
    return {
      websiteImg: utils.websiteImg,
      typeFilter: ['CURTAIN', 'BLIND', 'HARDWARE'],
      products: [],
      typeList: [],
      sleTypeData: '',
      total: 0,
      formData: {
        type: '',
        craftId: '',
        pageNo: 1,
        // pageSize: 8,
        categoryId: ''
      },
      loading: false,
      categoryName: ''
    };
  },
  computed: {
    ...mapGetters("app", ["getScreenWidth", "isMobile"]),
    screenWidth() {
      return this.getScreenWidth;
    },
  },
  created() {
    this.formData.type = this.$route.query.type || '';
    this.formData.categoryId = this.$route.query.categoryId || '';
    this.getList();
    this.formData.type == 2 ? '' : this.getType()
  },
  watch: {
    '$route.query': {
      handler(newVal) {
        this.sleTypeData = '';
        this.formData.craftId = '';
        this.formData.type = newVal.type || '';
        this.formData.categoryId = newVal.categoryId || '';
        this.categoryName = newVal.name || '';
        this.formData.pageNo = 1; // 重置页码
        this.products = [];
        this.formData.type != '' && this.getList();
        this.formData.type == 2 ? '' : this.getType()
      },
      immediate: false
    }
  },
  methods: {
    imageUtils,
    // 获取产品图片
    getProductImage(item) {
      if (!item || !item.productColorPojoList) return '';
      const activeColorObj = item.productColorPojoList[item.activeColorIdx];
      if (!activeColorObj) return '';
      const imgPath = activeColorObj.image || activeColorObj.cover;
      return this.imageUtils(this.websiteImg, imgPath);
    },
    // 筛选产品列表
    filterByType(data) {
      this.sleTypeData = data || '';
      this.formData.craftId = data.craftId || '';
      this.formData.pageNo = 1; // 重置页码
      this.getList(1);
    },
    getList(pageNo) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.8)'
      });
      // this.loading = true;
      this.formData.pageNo = pageNo || this.formData.pageNo;
      materialList(this.formData).then(res => {
        res.data.dataList.forEach(item => {
          item.activeColorIdx = 0
        })
        this.products = res.data.dataList;
        this.total = res.data.count;
      }).finally(() => {
        setTimeout(() => {
          // this.loading = false;
          loading.close();
        }, 200);
      });
    },
    getType() {
      productCraftList({ type: this.formData.type }).then(res => {
        this.typeList = res.data.dataList || [];
      });
    },

    // 色块点击切换事件
    switchColor(productIndex, colorIndex) {
      // this.products[productIndex].activeColorIdx = colorIndex;
      const targetProduct = this.products[productIndex];
      this.$set(targetProduct, 'activeColorIdx', colorIndex);
    },
    handleImageClick(item) {
      this.$router.push({ path: '/product', query: { product: item.proId } });
    }
  }
};
</script>

<style lang="scss" scoped>
$serif-font: 'NotoSerif', serif;
// $sans-font: 'Helvetica Neue', Helvetica, Arial, sans-serif;

.pagination-section {
  text-align: center;
  margin-top: 60px;

  ::v-deep .el-pagination {
    font-family: $serif-font;
    font-weight: normal;

    .btn-prev,
    .btn-next {
      background-color: transparent;
      color: #666;
      height: 32px;

      span {
        font-size: 14px;
      }
    }

    .el-pager li {
      background-color: transparent;
      color: #999;
      font-weight: normal;
      font-size: 14px;
      height: 32px;
      line-height: 32px;

      &.active {
        color: #000;
        font-weight: bold;
      }

      &:hover {
        color: #000;
      }
    }
  }
}
</style>